import { ROUTES } from '~/utils/routes';
import { useEditUserHeader } from './hooks';
import { EditUserHeaderPresentation } from './presentations';

type Props = {
  userId: number;
};

/**
 * 利用者編集ヘッダー Container コンポーネント
 * API から取得した利用者名をパンくずリスト付きヘッダーに表示する
 */
export const EditUserHeader: React.FC<Props> = ({ userId }) => {
  const { fullName } = useEditUserHeader({ userId });

  return <EditUserHeaderPresentation fullName={fullName} indexHref={ROUTES.USERS} />;
};
